import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FlowItemModel } from '../../models/FlowItemModel';

import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-note-card',
  imports: [
    CommonModule,
    MatCardModule, MatIconModule, MatDividerModule, MatButtonModule
  ],
  templateUrl: './note-card.component.html',
  styleUrls: ['./note-card.component.css']
})
export class NoteCardComponent implements OnInit {

  @Input() Note: FlowItemModel;
  constructor(private _router: Router) { }



  ngOnInit() {
  }

  gotoPlayerDetails(playerid: string) {
    this._router.navigateByUrl('/scouting/playerdetails/' + playerid);

  }

}
